import styled, { css } from 'styled-components'

const sizeVars = {
  small: () => css`
    --toggleWidth: 2.5rem;
    --toggleHeight: 1.25rem;
    --toggleInnerRadius: 1rem;
  `,
  medium: () => css`
    --toggleWidth: 3rem;
    --toggleHeight: 1.5rem;
    --toggleInnerRadius: 1.25rem;
  `
}

export const Container = styled.div<{
  isLoading: boolean
  size: 'small' | 'medium'
  textLeft?: boolean
}>`
  ${({ isLoading, size, textLeft }) => css`
    display: flex;
    justify-content: ${textLeft ? 'flex-start' : 'flex-end'};
    align-items: ${textLeft ? 'flex-start' : 'center'};
    gap: 8px;

    ${sizeVars[size]}

    input[type='checkbox'] {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      -webkit-tap-highlight-color: transparent;
      cursor: pointer;
      &:focus {
        outline: 0;
      }
    }

    .toggle {
      width: var(--toggleWidth);
      height: var(--toggleHeight);
      border-radius: 1rem;
      display: inline-block;
      position: relative;
      margin: 0;
      ${textLeft && 'margin-top: 2px;'}
      border: 0;
      background: var(--sl-bg-base-strong);
      transition: all 0.2s ease;
      box-shadow: 0 6px 16px -3px rgba(44, 44, 44, 0.1);

      &:after {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: var(--toggleInnerRadius);
        height: var(--toggleInnerRadius);
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.5);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
      }

      &:disabled {
        background: var(--sl-bg-base-disabled);
        cursor: not-allowed;
      }

      &:checked {
        background: var(--sl-color-green-6);
        &:after {
          transform: translateX(
            calc(
              var(--toggleWidth) - var(--toggleInnerRadius) -
                ${size === 'small' ? '6px' : '4px'}
            )
          );
        }

        &:disabled {
          background: color-mix(in srgb, var(--primary) 40%, transparent);
        }
      }

      ${isLoading &&
      css`
        background: color-mix(
          in srgb,
          var(--primary) 40%,
          transparent
        ) !important;
      `}
    }
  `}
`

export const Content = styled.div`
  width: calc(100% - var(--toggleWidth));
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ContentLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Label = styled.label`
  font-weight: 600;
  font-size: 14px;
  color: #2d2d2d;
  margin-bottom: 0;
`

export const Description = styled.span`
  font-size: 13px;
  color: #6b6b6b;
`
